import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'microsoft-outlook-trigger',
  name: 'Microsoft Outlook Trigger',
  category: 'triggers',
  description: 'Trigger workflows when new emails are received in Microsoft Outlook',
  icon: 'microsoft-outlook',
  iconType: 'microsoft-icon',
  color: 'blue',
  version: '1.0.0',

  group: ['trigger', 'schedule'],

  defaults: {
    name: 'Outlook Trigger',
    color: '#0078d4'
  },

  credentials: [
    {
      name: 'microsoft_outlook_oauth',
      required: true
    }
  ],

  subtitle: '={{ $parameter.pollMode === "everyXMinutes" ? "Poll every " + ($parameter.minuteInterval || 5) + " min" : $parameter.pollMode === "everyHour" ? "Poll every hour at :" + String($parameter.minute || 0).padStart(2, "0") : $parameter.pollMode === "everyDay" ? "Poll daily at " + String($parameter.hour || 9).padStart(2, "0") + ":" + String($parameter.minute || 0).padStart(2, "0") : $parameter.pollMode === "custom" ? ($parameter.cronExpression || "Custom schedule") : "Poll every 5 min" }}',

  inputs: [],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Main'
    }
  ],

  tags: ['outlook', 'email', 'microsoft', 'trigger', 'polling', 'mailbox'],

  comingSoon: false,

  metadata: {
    documentation: 'https://docs.microsoft.com/en-us/graph/api/resources/mail-api-overview'
  }
};

export default definition;
